import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../common/component/Wrapper';
import Dropdown from '../../common/component/Dropdown';
import Ripple from '../../common/component/Ripple';
import { Icon, Menu } from 'antd';
import { TRANSLATE_LANGUAGE, ALL_LANGUAGE_ENUM, CONFIG_LOCAL_STORAGE } from '../../../../constants/Define';
import Images from '../../../../constants/Images';

import { omit, find, toArray } from 'lodash';
import './LanguageSelect.less';
import { LocalStorage } from '../../../../utils';

const ALL_LANGUAGE = ALL_LANGUAGE_ENUM;
export default class LanguageSelect extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            currentLanguage: ALL_LANGUAGE,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.current !== this.props.current) {
            this.setState({ currentLanguage: this.props.current })
        }
    }

    componentDidMount() {
        this.setState({ currentLanguage: this.props.current })
    }

    render() {
        const { t, iconOnly, collapsed } = this.props;
        const { currentLanguage } = this.state;
        const currentLangObj = find(toArray(TRANSLATE_LANGUAGE), item => item.code === currentLanguage)
        return (
            <Dropdown overlay={
                <Menu onClick={this.onClick}>
                    {Object.keys(TRANSLATE_LANGUAGE).map(lang => (
                        <Menu.Item key={TRANSLATE_LANGUAGE[lang].code}>
                            <Wrapper className="w100-percent flex-center pt-1 pb-1 lang-item">
                                <img src={Images.flag.square[TRANSLATE_LANGUAGE[lang].id]}
                                    alt={t(`translate.languages.${TRANSLATE_LANGUAGE[lang].id}`)} className="flag-icon-16px mr-1" />
                                {t(`translate.languages.${TRANSLATE_LANGUAGE[lang].id}`)}
                                {currentLanguage === TRANSLATE_LANGUAGE[lang].code && <Icon type="check" className="ml-2" />}
                            </Wrapper>
                        </Menu.Item>
                    ))}
                </Menu>
            }>
                <Wrapper className={`hms-language-select ant-btn-group flex-center ${this.props.className || ''}`}>
                    {(!collapsed  || (collapsed && !(currentLangObj && currentLanguage !== ALL_LANGUAGE))) && 
                        <Ripple color="white" className={`ant-btn btn-default flex-center ${this.props.buttonClass || ''}`} waitForEffect={true}>
                            <Icon type="global" className="mr-1" />{!iconOnly && t(`translate.language`)}
                        </Ripple>
                    }
                    {currentLangObj && currentLanguage !== ALL_LANGUAGE &&
                        <Wrapper className={`ant-btn btn-default ant-btn-background-ghost flex-center btn-flag ${
                            collapsed ? 'w100-percent flex-center justify-center' : ''
                        }`}>
                            <img src={Images.flag.square[currentLangObj.id]}
                                alt={t(`translate.languages.${currentLangObj.id}`)} className="flag-icon-16px" />
                            <Ripple color="white" onClick={this.onRemove} className="btn-remove">
                                <Icon type="close" />
                            </Ripple>
                        </Wrapper>
                    }
                </Wrapper >
            </Dropdown>
        )
    }

    onClick = (event) => {
        const lang = event.key;
        if (lang !== this.state.currentLanguage) {
            this.setLanguage(event.key)
        } else {
            this.onRemove();
        }
    }

    onRemove = () => {
        this.setLanguage(ALL_LANGUAGE)
    }

    setLanguage = (lang) => {
        this.setState({ currentLanguage: lang });
        // LocalStorage.set(CONFIG_LOCAL_STORAGE.CONTENT_LANGUAGE, lang)
        this.props.onChange(lang)
    }

}
LanguageSelect.propTypes = {
    onChange: PropTypes.func,
    hideDefault: PropTypes.bool,
}
LanguageSelect.defaultProps = {
    onChange: (language) => { },
    hideDefault: false,
}